import { render, staticRenderFns } from "./relatedProductsModal.vue?vue&type=template&id=3f6ce37c"
import script from "./relatedProductsModal.vue?vue&type=script&lang=js"
export * from "./relatedProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports